import axios from "./axios-auth";

const uploadUserCreationFile = (file) => {
  const fileFormData = new FormData();
  fileFormData.append("batchfile", file);
  return new Promise((resolve, reject) => {
    axios
      .post("/hr-adm/getbatchusercreatedetails", fileFormData)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while response in batch user upload api");
      });
  });
};

const saveUserCreationFile = ({
  file,
  id,
  usersToUpdate,
  skipperdUsersCount,
}) => {
  const data = {
    batch_user_create_id: id,
    users_to_update: usersToUpdate.map((user) => ({
      ...user,
      update: undefined,
      points: user.points ?? 0,
    })),
    skipped_users_count: skipperdUsersCount,
  };
  console.log(data, JSON.stringify(data));
  const fileFormData = new FormData();
  fileFormData.append("batchfile", file);
  fileFormData.append("data", JSON.stringify(data));
  return new Promise((resolve, reject) => {
    axios
      .post("/hr-adm/savebatchusercreate", fileFormData)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while response in batch user upload api");
      });
  });
};

const getAuthorizedClients = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getauthorizedclients",
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while fetching authorized clients api");
      });
  });

const getTemplate = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/downloadfile?ft=usercreatebatch",
      method: "GET",
      responseType: "blob",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while fetching authorized clients api");
      });
  });

const downloadExcelFile = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/downloadfile",
      method: "GET",
      params: params,
      responseType: "blob",
    })
      .then((resp) => {
        if (resp.status !== 200) {
          reject(resp);
        }
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error downloadExcelFile api");
      });
  });

const getUploads = ({ current, pageSize, viewAllUploads }) =>
  new Promise((resolve, reject) => {
    axios({
      url: `/hr-adm/getbatchusercreatefiles?pg_num=${current}&pg_size=${pageSize}&viewAllUploads=${viewAllUploads}`,
      method: "GET",
    })
      .then(({ data }) => {
        resolve({ ...data, result: data.result ?? [] });
      })
      .catch(() => {
        console.log("error while fetching authorized clients api");
      });
  });

export {
  uploadUserCreationFile,
  getAuthorizedClients,
  getTemplate,
  getUploads,
  saveUserCreationFile,
  downloadExcelFile,
};
